import { useEffect, useState } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
// import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import SelectField from '../../components/Forms/Input/SelectField';
import useHardwareTest from '../../hooks/hardware/useHardwareTest';
import { useBranch } from '../../hooks/branches/useBranch';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const TestPrinter = () => {
  const { testPrinter, isTesting } = useHardwareTest();
  const { fetchBranchDropdown, branchDropdown } = useBranch();

  const [selectedBranchId, setSelectedBranchId] = useState<number | ''>('');

  useEffect(() => {
    fetchBranchDropdown();
  }, []);

  const handleTest = async () => {
    if (!selectedBranchId) return;
    await testPrinter(selectedBranchId);
  };

  return (
    <DefaultLayout>
      {/* <Breadcrumb pageName="Prueba de Impresora" /> */}
      <BreadcrumbTwo />


      <div className="rounded border border-gray-200 bg-white p-6 shadow dark:border-gray-700 dark:bg-boxdark space-y-6">
        <p className="text-gray-600 dark:text-gray-300">
          Seleccione una sucursal para imprimir una hoja de prueba desde su impresora asignada.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <SelectField
            label="Sucursal"
            name="branchId"
            iconKey="building"
            value={selectedBranchId}
            onChange={(e) => setSelectedBranchId(Number(e.target.value))}
            options={branchDropdown.map((branch) => ({
              label: branch.name,
              value: branch.id,
            }))}
            placeholder="Seleccione la sucursal"
          />
        </div>

        <div className="pt-4">
          <button
            onClick={handleTest}
            disabled={!selectedBranchId || isTesting}
            className="rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90 disabled:opacity-50"
          >
            {isTesting ? 'Imprimiendo...' : 'Imprimir hoja de prueba'}
          </button>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default TestPrinter;
